import { render } from "./EmailInput.vue?vue&type=template&id=5b6afb66&scoped=true"
import script from "./EmailInput.vue?vue&type=script&lang=js"
export * from "./EmailInput.vue?vue&type=script&lang=js"

import "./EmailInput.vue?vue&type=style&index=0&id=5b6afb66&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6afb66"]])

export default __exports__